<template>
  <!-- Footer  -->
  <footer class="footer">
    <div class="container">



    <div class="row">
    <div class="col-xs-12 col-xsm-6 col-sm-6 col-md-3 col-lg-4 mb-40 col-1">
      <p class="logo-footer">
        <Logo  class="logo"/>
        <span class="slogan">Tech Innovating Development</span>
      </p>
      <div class="footer-social">
        <ul class="list-inline">
           <li> <a href="#"> <i class="fa fa-facebook"></i> </a> </li>
            <li> <a href="#"> <i class="fa fa-twitter"></i> </a> </li>
           <li> <a href="#"> <i class="fa fa-instagram"></i> </a> </li>
           <li> <a href="#"> <i class="fa fa-linkedin"></i> </a> </li>
        </ul>
        </div>
    </div>
    <div class="col-xs-12 col-xsm-6 col-sm-6 col-md-4 col-lg-4  mb-40  col-2">
      <h3>Subscribe</h3>
      <p>Get insights, inspiration and updates</p>
      <form>
        <div class="input-group signup"> <input type="email" class="form-control" placeholder="Email address" /> <div class="input-group-addon"><button type="submit" class="btn btn-primary btn-block">Submit <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
 viewBox="0 0 57.86 8.49" style="enable-background:new 0 0 57.86 8.49;" xml:space="preserve"><g><g>
        <line class="st0" x1="0.34" y1="4.36" x2="56.77" y2="4.36"></line>
        <g><polygon class="st1" points="53.46,8.45 52.78,7.72 56.39,4.36 52.78,1.01 53.46,0.27 57.86,4.36"></polygon> </g></g></g></svg></button></div> </div>
      </form>

    </div>

    <div class="col-xs-12 col-xsm-6 col-sm-6 col-md-2 col-lg-2  mb-40  col-3">
      <h3>Company</h3>
      <ul>
        <li><a href="#">What We Do</a></li>
        <li><a href="#">Capital Finder</a></li>
        <li><a href="#">Crowdfunding</a></li>
        <li><a href="#">Contact</a></li>
        <li><a href="#">Careers</a></li>
      </ul>
    </div>
    <div class="col-xs-12 col-xsm-6 col-sm-6 col-md-3 col-lg-2  mb-40  col-4">
      <h3>Contact</h3>
      <p>AlliedCrowds <br>
        115 Mare St <br>
        E8 4RU <br>
        London</p>
      <p><a href="mailto:info@alliedcrowds.com">info@alliedcrowds.com</a></p>
    </div>
    </div>
    <p class="site-info text-sm-left">&copy; 2019 Allied Crowds</p>
    </div>
  </footer>
  <!-- Footer close -->
</template>

<script>
import Logo from '../assets/images/logo.svg'

export default {
  components: {
    Logo
  },
  name: '',
}
</script>
